import { Injectable } from '@angular/core';
import { ConfigService } from '../../../../utils/config-service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Alert } from '../../models/alert';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class AlertApiService {
    private alertUrl: string;

    constructor(private http: HttpClient, private configService: ConfigService) {
        this.alertUrl = this.configService.getEnv('alertApi');
    }

    getAlertsByUser(): Observable<Alert[] | {}> {
        let url = this.alertUrl + 'user';
        return this.http.get(url)
            .map((result: any) => {
                return result.map((alertJson: any) => new Alert(alertJson));
            }).catch((error: any) => {
                return undefined;
            });
    }

    getAlertsByJob(jobId: string): Observable<Alert[] | {}> {
        let url = this.alertUrl + 'job/' + jobId;
        return this.http.get(url)
            .map((result: any) => {
                return result.map((alertJson: any) => new Alert(alertJson));
            }).catch((error: any) => {
                return undefined;
            });
    }

    createAlert(alert: Alert): Observable<any> {
        let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
        return this.http.post(this.alertUrl, JSON.stringify(alert), { headers: headers })
            .map((result: any) => {
                return result.id;
            }).catch((error: any) => {
                return undefined;
            });
    }

    deleteAlert(alertId: string): Observable<any> {
        let url = this.alertUrl + alertId;
        return this.http.delete(url);
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/domain/services/alert/alert.api.service.ts